const facts = [
  { label: "Game drives", sub: "& Guided walks" },
  { label: "Boma Dinners", sub: "& Bushveld Picnics" },
  { label: "African Spa", sub: "Treatments" },
  { label: "Malaria Free", sub: "Region" },
  { label: "Airconditioned", sub: "Rooms" },
  { label: "Swimming Pool", sub: "Poolside relaxation" },
  { label: "2hrs", sub: "From Johannesburg" },
  { label: "20 Guests", sub: "Maximum capacity" },
];

const FastFacts = () => {
  return (
    <section className="bg-secondary py-4 sm:py-6 lg:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-0">
        <h2 className="font-heading tracking-[0.15em] uppercase text-foreground text-center mb-12 text-xl">
          Fast Facts
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {facts.map((f) => (
            <div
              key={f.label}
              className="bg-card border border-border rounded p-6 text-center"
            >
              <p className="font-heading text-base text-foreground mb-1">
                {f.label}
              </p>
              <p className="text-xs text-muted-foreground">{f.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FastFacts;
